module.exports = __webpack_public_path__ + "img/home_business_item3_1.e9af9d79.jpg";